module.exports = __webpack_public_path__ + "static/media/History.8f7e18ab.svg";